import { Banner } from '@chillibean/component-library/legacy';
import _ from 'lodash';
import { cloneElement, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams, matchPath, useLocation } from 'react-router-dom';

import { setFormTemplate, setFormTemplateVersion } from '../../redux/actions/formTemplateActions';
import { templateVersionExists, getLatestFormTemplateVersion, selectTemplateByVersionNo } from '../../utils/utils';
import FormTemplateNavBar from '../presentational/FormTemplateNavBar/FormTemplateNavBar';
import FormTemplateError from './FormTemplateError';

export function CurrentFormTemplateContainer(props) {
  const { setFormTemplate, setFormTemplateVersion, allFormTemplates, formTemplateRequestLoading } = props;
  const { templateId, version_number } = useParams();
  const currentFormTemplate = allFormTemplates[templateId];
  const latestFormTemplateVersion = currentFormTemplate?.versions[0];
  const [currentUrl, setCurrentUrl] = useState(window.location.href);

  useEffect(() => {
    if (!currentFormTemplate) return;

    setFormTemplate(currentFormTemplate);

    if (version_number) {
      setFormTemplateVersion(_.cloneDeep(selectTemplateByVersionNo(version_number, currentFormTemplate)));
    } else {
      setFormTemplateVersion(_.cloneDeep(getLatestFormTemplateVersion(currentFormTemplate)));
    }
  }, [currentFormTemplate, allFormTemplates, version_number, templateId, setFormTemplate, setFormTemplateVersion]);

  if (currentUrl !== window.location.href) {
    setCurrentUrl(window.location.href);
  }
  const currentPath = useLocation().pathname;
  const isEditPage = matchPath(currentPath, { path: '/:templateId/edit' });
  const isVersionFormPage = matchPath(currentPath, {
    path: '/:templateId/versions/:version_number',
  });
  const isVersionsPage = matchPath(currentPath, {
    path: '/:templateId/versions/',
  });
  const isHomePage =
    matchPath(currentPath, { path: '/', exact: true }) ||
    matchPath(currentPath, {
      path: '/:displaytype',
      exact: true,
    });
  const isCreatePage = matchPath(currentPath, { path: '/new' });
  const isWorkflowsPage = matchPath(currentPath, { path: '/:templateId/workflows' });

  const displayTitle = () => {
    // don't display title on edit and version form page
    if (isEditPage || isVersionFormPage) return <></>;
    return (
      <div className="form-template-header__title-section-wrapper">
        <div className="form-template-header__title-section">
          <div className="form-template-header__title">
            {latestFormTemplateVersion && (
              <div className="form-template-header__id">{latestFormTemplateVersion.id}</div>
            )}
            <h1>{latestFormTemplateVersion?.title}</h1>
          </div>
        </div>
      </div>
    );
  };

  const invalidTemplateVersion = () => {
    return (
      !formTemplateRequestLoading &&
      currentFormTemplate &&
      version_number &&
      !templateVersionExists(version_number, currentFormTemplate)
    );
  };

  const invalidTemplate = () => {
    return !formTemplateRequestLoading && currentFormTemplate === undefined;
  };

  if (isHomePage || isCreatePage) {
    return (
      <>
        <FormTemplateError source="api" handleLog />
        {props.children}
      </>
    );
  }
  if (invalidTemplateVersion()) {
    return <FormTemplateError source="templateVersionId" />;
  }
  if (invalidTemplate()) {
    return <FormTemplateError source="templateId" />;
  }
  return (
    <>
      <FormTemplateNavBar />
      {!isVersionsPage && !isVersionFormPage && <FormTemplateError source="api" handleLog />}
      {isWorkflowsPage && (
        <div className="form-template-workflow-banner">
          <Banner type="info">
            <b>Just so you know:</b> Once a form has been created from a template, the workflow can no longer be
            changed.
          </Banner>
        </div>
      )}
      <div className="template-builder_content-wrapper">
        {displayTitle()}
        {cloneElement(props.children, {
          formTemplate: currentFormTemplate,
        })}
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    allFormTemplates: state.formTemplateApiReducer.formTemplates,
    formTemplateRequestLoading: state.formTemplateApiReducer.formTemplateRequest.loading,
  };
};

const mapDispatchToProps = {
  setFormTemplate,
  setFormTemplateVersion, // this is setting a Form Template Version, used for edit form and version preview form
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentFormTemplateContainer);
